import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export const CrmRoutes = {
    "/brand/:brand_id/crm?tab": {
        "name": "appLayout.harriSH.crm",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["branded_comms"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./crm.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/branded-comms/branded-comms.module.js");
                }
            }
        ]
    },
    "/campaign/create?campaign_id&brand_id&source": {
        "name": "appLayout.harriSH.create-campaign",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["branded_comms"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./crm.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/branded-comms/branded-comms.module.js");
                }
            }
        ]
    },
    "/email/create?email_id&brand_id&source": {
        "name": "appLayout.harriSH.create-email",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["branded_comms"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./crm.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/branded-comms/branded-comms.module.js");
                }
            }
        ]
    },
    "/campaign/unsubscribe?token": {
        "name": "campaign-unsubscribe",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["branded_comms"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./crm.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/branded-comms/branded-comms.module.js");
                }
            }
        ]
    },
    "/:view?tab": {
        "name": "appLayout.harriSH.settings.brandSection",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["branded_comms"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./crm.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/branded-comms/branded-comms.module.js");
                }
            }
        ]
    },
    [`/crm/${hmapPathParamRegex}?tab`]: {
        "name": "appLayout.harriSH.access-portal.settings.crm",
        "params": {
            ...hmapPathParamConfig
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./crm.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../branded-comms/branded-comms.module.js");
                }
            }
        ]
    }
};